import React, { useState } from "react";


import star from "./../../../assets/images/star.svg"; // Adjust the path as necessary
import ssoImg1 from "./../../../assets/images/218.png"; // Adjust the path as necessary
import ssoImg2 from "./../../../assets/images/mrcc-2.png"; // Adjust the path as necessary
import ssoImg3 from "./../../../assets/images/299.png"; // Adjust the path as necessary
import shipIcon from "./../../../assets/images/ship.svg"; // Adjust the path as necessary
import viselIcon from "./../../../assets/images/visel.svg"; // Adjust the path as necessary
import pilotIcon from "./../../../assets/images/user-pilot-tie.svg"; // Adjust the path as necessary
import scaleIcon from "./../../../assets/images/scale-balanced.svg"; // Adjust the path as necessary
import doubleUserIcon from "./../../../assets/images/double-user.svg"; // Adjust the path as necessary
import multiUserIcon from "./../../../assets/images/user-add.svg"; // Adjust the path as necessary
import trustExclimationIcon from "./../../../assets/images/trust-exclamation.svg"; // Adjust the path as necessary
import hookDownIcon from "./../../../assets/images/hook-icon.svg"; // Adjust the path as necessary
import hookUpIcon from "./../../../assets/images/hook-up.svg"; // Adjust the path as necessary
import noteCheckIcon from "./../../../assets/images/note-check.svg"; // Adjust the path as necessary
import trustIcon from "./../../../assets/images/trust-icon.svg"; // Adjust the path as necessary
import noteTickIcon from "./../../../assets/images/clipboard-check.svg"; // Adjust the path as necessary



import { FaFacebookF, FaLinkedinIn, FaTwitter, FaYoutube, FaUser, FaInstagram } from 'react-icons/fa';

function LegislationOverview() {
    const cardData = [
  {
    icon: shipIcon,
    shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
    twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
    linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
    ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
    cardDescription: "Merchant Shipping Act, 1951",
  },
  {
    icon: viselIcon,
    shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
    twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
    linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
    ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
    cardDescription: "Marine Traffic Act, 1981",
  },
  {
    icon: pilotIcon,
    shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
    twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
    linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
    ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
    cardDescription: "Marine Pollution (Control and Civil Liability) Act, 1981",
  },
  {
    icon: scaleIcon,
    shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
    twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
    linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
    ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
    cardDescription: "Carriage of Goods by Sea Act, 1986",
},
{
    icon: doubleUserIcon,
    shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
    twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
    linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
    ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
    cardDescription: "Marine Pollution (Prevention of Pollution from Ships) Act, 1986",
  },
  {
    icon: multiUserIcon,
    shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
    twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
    linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
    ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
    cardDescription: "Marine Pollution (Intervention) Act, 1987",
  },
  {
    icon: trustExclimationIcon,
    shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
    twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
    linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
    ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
    cardDescription: "Maritime Zones Act, 1994",
  },
  {
    icon: hookDownIcon,
    shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
    twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
    linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
    ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
    cardDescription: "Wreck and Salvage Act, 1996 ",
},
{
    icon: noteCheckIcon,
    shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
    twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
    linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
    ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
    cardDescription: "SAMSA Act, 1998",
  },
  {
    icon: trustIcon,
    shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
    twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
    linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
    ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
    cardDescription: "SAMSA Levies Act, 1998",
  },
  {
    icon: noteTickIcon,
    shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    fbLink: "https://www.facebook.com/sharer/sharer.php?u=https://www.samsa.org.za/latest-marine-info",
    twitterLink: "https://twitter.com/intent/tweet?url=https://www.samsa.org.za/latest-marine-info",
    linkedinLink: "https://www.linkedin.com/sharing/share-offsite/?url=https://www.samsa.org.za/latest-marine-info",
    instaLink: "https://www.instagram.com/?url=https://www.samsa.org.za/latest-marine-info",
    ytLink: "https://www.youtube.com/share?url=https://www.samsa.org.za/latest-marine-info",
    cardDescription: "Ship Registration Act, 1998",
},

  
  
  

  
];



  return (
    <>
      <div className="service-title font-700 mb-3 text-uppercase">
        LEGISLATION
        <span className="text-orange-ef3e33 font-400"> OVERVIEW </span>
      </div>
      <p className="mb-3 text-primary-color">
        The South African Maritime Safety Authority (“SAMSA”) was established in
        terms of SAMSA Act, 1998
        <br />
        (“the Act”) as a juristic person.
        <br />
        Its objectives are―
      </p>
      <div className="row g-3 g-sm-4 g-md-5">
        <div className="col-lg">
          <div className="x-scroll mb-4">
            <div className="service-block-wrap align-items-start">
              <div className="service-block">
                <div className="ratio-73 bg-green-38B652 d-flex align-items-center justify-content-center rounded-circle mb-3">
                  <img
                    src={star}
                    width={38}
                    className="img-fluid white-filter"
                    alt=""
                  />
                </div>
                <p>to ensure safety of life and property at sea</p>
              </div>
              <div className="service-block">
                <div className="ratio-73 bg-gray-7d9199 d-flex align-items-center justify-content-center rounded-circle mb-3">
                  <img
                    src={star}
                    width={38}
                    className="img-fluid white-filter"
                    alt=""
                  />
                </div>
                <p>
                  to prevent and combat pollution of the marine environment by
                  ships
                </p>
              </div>
              <div className="service-block">
                <div className="ratio-73 bg-green-38B652 d-flex align-items-center justify-content-center rounded-circle mb-3">
                  <img
                    src={star}
                    width={38}
                    className="img-fluid white-filter"
                    alt=""
                  />
                </div>
                <p>to promote the Republic’s maritime interests.</p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-5">
          <img src={ssoImg1} className="img-fluid rounded-1" alt="" />
        </div>
        <div className="col-12">
          <p className="mb-3 text-primary-color">
            {" "}
            In terms of section 2 of the Act, SAMSA is responsible to administer
            the following pieces of legislation:
          </p>
          <div className="row g-4">
            {cardData.map((card, index) => (
              <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6" key={index}>
                <div className="gray-card-wrap">
                  <div className="gray-card bg-gray-de bg-opacity-10 d-flex flex-column align-items-center">
                    <div className="icon">
                      <img src={card.icon} alt="" />
                    </div>
                    <div className="text-center text-primary-color">
                      {card.cardDescription}
                    </div>

                    <div className="card-share">
                      {/* <button type="button" className="btn-share border-0">
                        <i className="bi bi-share"></i>
                      </button> */}
                      <ul>
                        <li>
                          <a href="#">
                            <FaFacebookF />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <FaTwitter />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <FaLinkedinIn />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <FaInstagram />
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <FaYoutube />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="col-12">
          <p className="mb-3 text-primary-color">
            {" "}
            {/* With regard to the aforementioned, the Centre for Policy and
            Regulatory Affairs (“the Centre”) is
            <br /> responsible for */}
            The Policy and Regulatory Affairs unit is responsible for
          </p>

          <div className="row g-4">
            <div className="col-lg-6 col-md-12 col-sm-6">
              <div className="gray-card-wrap">
                <div className="gray-card bg-gray-de bg-opacity-10 d-flex flex-column align-items-center">
                  <div className="icon">
                    <img src={pilotIcon} alt="" />
                  </div>
                  <div className="text-center text-primary-color">
                    Providing assistance to the Department of Transport in
                    drafting and processing of the maritime statutes and
                    policies, leading to the promulgation into laws of South
                    Africa. Further, the Centre also plays a critical role on
                    consultation processes with internal and external
                    stakeholders (government departments and its entities,
                    private stakeholders etc.) in developing legal instruments. 
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-6">
              <div className="gray-card-wrap">
                <div className="gray-card bg-gray-de bg-opacity-10 d-flex flex-column align-items-center">
                  <div className="icon">
                    <img src={hookUpIcon} alt="" />
                  </div>
                  <div className="text-center text-primary-color">
                    Advocating for the adoption of international regulations
                    (Conventions, Protocols, Codes etc.) and assist in
                    translating such into national laws including leveraging
                    international best practice.
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-6">
              <div className="gray-card-wrap">
                <div className="gray-card bg-gray-de bg-opacity-10 d-flex flex-column align-items-center">
                  <div className="icon">
                    <img src={pilotIcon} alt="" />
                  </div>
                  <div className="text-center text-primary-color">
                    Providing regular updates to SAMSA on legislative and
                    regulatory changes. It also conducts research on various
                    legislative​e and regulatory frameworks that impact on SAMSA
                    and make necessary recommendations.
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-6">
              <div className="gray-card-wrap">
                <div className="gray-card bg-gray-de bg-opacity-10 d-flex flex-column align-items-center">
                  <div className="icon">
                    <img src={hookUpIcon} alt="" />
                  </div>
                  <div className="text-center text-primary-color">
                    Providing legal advice and opinions on maritime related
                    issues as well as on corporate legal matters to government
                    departments upon request.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-12">
          <div className="row">
            <div className="col-12">
              <img src={ssoImg3} className="img-fluid" alt="" />
            </div>
            <div className="col-md-12">
              <div className="bg-gray-7d9199 p-4 text-white me-7">
                {/* <h4 className="text-center font-17 font-700 mb-2">STATUTARY FORMS</h4> */}
                <p className="font-17">For guidance on applicable national laws; relavent regional; continental and international instrument; Please see Related Information links or contact your nearest</p>
              </div>
            </div>
            {/* <div className="col-md-6">
              <div className="bg-gray-ee p-4">
                <h4 className="text-center font-17 font-700 mb-2">SAMSA OFFICES</h4>
                <p className="font-17">ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,  quis nostrud exercitation ullamco laboris nisi</p>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
}

export default LegislationOverview;